import * as I18n from 'circe/I18n';
import moment from 'moment';

export const getPageTitleFromFilters = (filters = {}) => {
  if (filters.status === 'next24Hours') {
    return I18n.str('shipmentPlanning', 'Shipment Planning (24hrs)');
  } if (filters.status === 'alerts') {
    return I18n.str('shipmentAlerts', 'Shipment Alerts');
  }
  return I18n.str('currentShipmentEscalation', 'Current Shipment Escalation');
};

export const makeFetchPayloadFromFilters = (filters = {}) => {
  let newFilters = {};
  switch (filters.status) {
    case 'alerts':
      newFilters = {
        sdate: moment().valueOf(),
        edate: moment()
          .add(24, 'hours')
          .valueOf(),
        pickup: 'ALERT',
      };
      break;
    case 'next24Hours':
      newFilters = {
        sdate: moment().valueOf(),
        edate: moment()
          .add(24, 'hours')
          .valueOf(),
      };
      break;
    case 'cancelled':
    default:
      newFilters = {
        sdate: moment()
          .subtract(15, 'days')
          .valueOf(),
        edate: moment()
          .add(10, 'days')
          .valueOf(),
        status: 'UNASSIGNED',
      };
      break;
  }

  return {
    // add here shared filter
    //
    ...newFilters,
  };
};
